export const PERMISSION_COUNT_REQUEST = 'PERMISSION_COUNT_REQUEST';
export const PERMISSION_COUNT_SUCCESS = 'PERMISSION_COUNT_SUCCESS';
export const PERMISSION_COUNT_FAILURE = 'PERMISSION_COUNT_FAILURE';
